export const CACHED_OBJECTS = {
  PRODUCTS: 'PRODUCTS',
  WORKPLACES: 'WORKPLACES',
  WORKPLACES_HISTORY: 'WORKPLACES_HISTORY',
  OPERATIONS: 'OPERATIONS',
  WORKORDERS: 'WORKORDERS',
  USERS: 'USERS',
  INPUT_DATA: 'INPUT_DATA',
  ROUTING: 'ROUTING',
  LOOKUPS: 'LOOKUPS',
  LOOKUPS_HISTORY: 'LOOKUPS_HISTORY',
}
